import { render, staticRenderFns } from "./tetrisunclaimed.vue?vue&type=template&id=4ea4bdef&"
import script from "./tetrisunclaimed.vue?vue&type=script&lang=js&"
export * from "./tetrisunclaimed.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./tetrisunclaimed.vue?vue&type=style&index=1&id=4ea4bdef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports